/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Delete Icon component.
 */
export const SystemDeleteIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M17.8055 6.94434V20.2499C17.8055 20.526 17.5816 20.7499 17.3055 20.7499H6.47217C6.19603 20.7499 5.97217 20.526 5.97217 20.2499V6.94434' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M4 4.26758H19.7777' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M8.93018 3L14.8468 3' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
    </svg>
  );
};

export default SystemDeleteIcon;
